/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import vm from "../../main.js";

import pouch from "@/db/pouch";

export default {
  addFarm({
    commit
  }, farm) {
    return new Promise(async (resolve, reject) => {
      try {
        return await pouch.c(farm, false).then((co) => {
          if (co.ok) {
            return resolve("Farm successfully registered");
          }
          return reject(co.message);
        });
      } catch (e) {
        return reject(e);
      }
    });
  },
  updateFarm({
    commit
  }, farm) {
    return new Promise(async (resolve, reject) => {
      return await pouch
        .f({
            selector: {
              _id: farm._id,
              z: 6,
            },
          },
          true,
          false
        )
        .then(async (sr) => {
          if (sr.hasOwnProperty("a")) {
            return await pouch
              .c(farm, false)
              .then((ct) => {
                if (ct.ok) {
                  return resolve("Farm successfully updated");
                }
                return reject(ct.message);
              })
              .catch((e) => reject(e));
          } else {
            return reject(
              "This farm has not been found. He/she might no longer exist in your database."
            );
          }
        });
    });
  },
};